import { RootState } from '../store';

export const selectPatient = (state: RootState): any => state.selectedPatient;
